module.exports = __webpack_public_path__ + "62137a998d754061ba24ed47ea5edda8.ttf";